import { Action } from 'redux';

export const CLEAR_EXPIRED_PRODUCTS = 'CLEAR_EXPIRED_PRODUCTS';

export const clearExpiredProducts = (): Action => ({
  type: CLEAR_EXPIRED_PRODUCTS
});
